<template>
  <!-- Pins its actions to the bottom of the scroll container with a solid
       background plane and a top divider. Used by the extension floating
       window so Close/Save (and the collection-picker submit) stay visible. -->
  <div class="StickyActionBar px-4 py-3">
    <slot />
  </div>
</template>

<script setup>
</script>

<style lang="scss" scoped>
.StickyActionBar {
  position: sticky;
  bottom: 0;
  z-index: 3;
  // Never collapse when used as a flex child (app-shell footer).
  flex: 0 0 auto;
  // Same color as the page background, theme-aware (light/dark).
  background-color: rgb(var(--v-theme-neutral0));
  // Natural divider color used across the app's forms.
  border-top: 1px solid rgb(var(--v-theme-neutral50));
}
</style>
